// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  backendBaseURL: 'https://us-central1-orderax-store.cloudfunctions.net',
  //backendBaseURL: 'http://localhost:5001/orderax-store/us-central1',
  siteBaseURL: 'http://orderax-store.web.app',
  production: false,
  clientId: '861906427287-a452a97rn7sb8nbn8v8rh7qvrdbfv7ia.apps.googleusercontent.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
